export default __webpack_public_path__ + "i18n/translation-te.e0fb4969.json";